// extracted by css-extract-rspack-plugin
export default {"linkToFlowContent":"link-to-node__linkToFlowContent___TAcy0"};